import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/degodsbg.png'
import _imports_1 from '../assets/deadgods.png'
import _imports_2 from '../assets/deadgodslogo.png'


const _withScopeId = n => (_pushScopeId("data-v-9ec89f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-40"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-3xl sm:text-6xl p-3 staking-title" }, "DEGODS STAKING", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_6 = { class: "justify-center w-full flex flex-col" }
const _hoisted_7 = { class: "flex flex-col sm:flex-row justify-center" }
const _hoisted_8 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Total DeGods Staked", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-6xl farm-value"
}
const _hoisted_11 = {
  key: 1,
  class: "text-6xl farm-value"
}
const _hoisted_12 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "% of DeGods Staked", -1))
const _hoisted_14 = {
  key: 0,
  class: "text-6xl farm-value"
}
const _hoisted_15 = {
  key: 1,
  class: "text-6xl farm-value"
}
const _hoisted_16 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Minimum Value Locked", -1))
const _hoisted_18 = {
  key: 0,
  class: "text-6xl farm-value"
}
const _hoisted_19 = {
  key: 1,
  class: "text-6xl farm-value"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col items-center justify-center welcome-container"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome-item welcome-image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "welcome-image",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "welcome-logo",
    src: _imports_2
  })
], -1))
const _hoisted_24 = { class: "welcome-item welcome-text" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2" }, "You need a staking account to get started!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "is-full-page": _ctx.fullPage,
      loader: _ctx.loader
    }, null, 8, ["active", "is-full-page", "loader"]),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (_ctx.farmAcc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.farmAcc?.gemsStaked), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(0)))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (_ctx.farmAcc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(Math.floor((parseInt(_ctx.farmAcc?.gemsStaked) / 9465.0) * 100 * 10) /
              10) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(0) + "%"))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (_ctx.farmAcc && _ctx.magicEdenFloor && _ctx.solPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " $" + _toDisplayString(Intl.NumberFormat('en-US')
                .format(
                  Math.floor(
                    parseInt(_ctx.farmAcc?.gemsStaked) *
                      _ctx.magicEdenFloor *
                      _ctx.solPrice *
                      100
                  ) / 100
                )
                .split('.')[0]), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, "$" + _toDisplayString(0)))
              ])
            ]),
            _createVNode(_component_ConfigPane)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farmerAcc: _ctx.farmerAcc,
                  farmerState: _ctx.farmerState,
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onFlashDepositWalletNft: _ctx.flashDepositSelectedNFT,
                  onFetchFarm: _ctx.fetchFarn,
                  onFetchFarmer: _ctx.fetchFarmer
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "mr-5 bg-purple-700 hover:bg-purple-700 text-white font-semibold hover:text-white py-2 px-4 border border-purple-500 hover:border-transparent rounded",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                    }, " Claim $DUST ")
                  ]),
                  _: 1
                }, 8, ["vault", "farmerAcc", "farmerState", "onSelectedWalletNft", "onFlashDepositWalletNft", "onFetchFarm", "onFetchFarmer"])
              ]))
            : (!_ctx.farmerAcc && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("button", {
                      class: "stake-btn bg-purple-700 hover:bg-purple-700 text-white font-semibold hover:text-white py-2 px-4 border border-purple-500 hover:border-transparent rounded",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                    }, " Create Account ")
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
  ], 64))
}